export default __webpack_public_path__ + "static/media/OIL SEAL PRESSING MACHINE.18b40d0c.png";